import styled from 'styled-components'
import { black, purpleSec, violet, white } from 'theme/colors'
import { DEVICES } from 'theme/devicesSizes'

export const InvestmentCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  padding: 24px;
  background-color: ${white};
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  gap: 16px;
  height: 200px;
  @media ${DEVICES.mobile} {
    height: 130px;
    gap: 0;
  }
`

export const InvestmentCardTitle = styled.text`
  font-size: 20px;
  font-weight: 500;
  color: ${black};
  display: block;
  text-align: center;
  @media ${DEVICES.mobile} {
    font-size: 12px;
  }
`

export const InvestmentCardSubtitle = styled.text`
  font-size: 16px;
  font-weight: 500;
  color: gray;
  display: block;
  text-align: center;
  @media ${DEVICES.mobile} {
    font-size: 10px;
    margin-top: 5px;
  }
`

export const InvestmentButton = styled.div`
  display: flex;
  align-items: center;
  align-self: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  background-color: ${purpleSec};
  border-radius: 5px;
  padding: 12px;
  gap: 10px;
  font-size: 10px;
  font-weight: 500;
  color: ${violet};
  @media ${DEVICES.tablet} {
    width: 300px;
  }
  @media ${DEVICES.mobile} {
    background-color: transparent;
    font-size: 13px;
    padding: 0;
    height: 30px;
  }
`

export const InvestmentLegend = styled.text`
  font-size: 12px;
  font-weight: 600;
  color: ${violet};
  @media ${DEVICES.mobile} {
    font-size: 13px;
  }
`
